export default __webpack_public_path__ + "5fe34e22c95221f465e4e258d94e4783.png";